import {Dispatch} from 'redux';
import {UserSettings} from '../../models/IUserSettings';
import {BAUTH_TOKEN_HEADER} from '../../config/config';
import {parseJWT} from '../../Util/jwtTokenParse';
import moment from 'moment';

export const FETCHING_SSO_USER_ACEPID = 'FETCHING_SSO_USER_ACEPID';
export const SET_SSO_USER_ACEPID_FULFILLED = 'SET_SSO_USER_ACEPID_FULFILLED';
export const SET_SSO_USER_ACEPID_FAILED = 'SET_SSO_USER_ACEPID_FAILED';

export const FETCHING_USER_SETTINGS_BY_ACEPID =
  'FETCHING_USER_SETTINGS_BY_ACEPID';
export const SET_USER_SETTINGS_BY_ACEPID_FULFILLED =
  'SET_USER_SETTINGS_BY_ACEPID_FULFILLED';
export const SET_USER_SETTINGS_BY_ACEPID_FAILED =
  'SET_USER_SETTINGS_BY_ACEPID_FAILED';

export interface FetchingSSOUserACEPIdAction {
  type: 'FETCHING_SSO_USER_ACEPID';
}
export interface SetSSOUserACEPIdFulfilled {
  type: 'SET_SSO_USER_ACEPID_FULFILLED';
  acepID: string;
}
export interface SetSSOUserACEPIdFailed {
  type: 'SET_SSO_USER_ACEPID_FAILED';
  error: string;
}
export interface FetchingUserSettingsByACEPIDAction {
  type: 'FETCHING_USER_SETTINGS_BY_ACEPID';
}
export interface SetUserSettingsByACEPIDFulfilled {
  type: 'SET_USER_SETTINGS_BY_ACEPID_FULFILLED';
  userSettings: UserSettings;
  ssoUser: string;
}
export interface SetUserSettingsByACEPIDFailed {
  type: 'SET_USER_SETTINGS_BY_ACEPID_FAILED';
  error: string;
}

export type KnownAction =
  | FetchingUserSettingsByACEPIDAction
  | SetUserSettingsByACEPIDFulfilled
  | SetUserSettingsByACEPIDFailed
  | FetchingSSOUserACEPIdAction
  | SetSSOUserACEPIdFulfilled
  | SetSSOUserACEPIdFailed;

export const actionCreators = {
  getUserSettingslByACEPID: (ACEPID: string) => {
    return async (dispatch: Dispatch<KnownAction>) => {
      const headers = new Headers();
      headers.set('Authorization', BAUTH_TOKEN_HEADER);
      dispatch({
        type: FETCHING_USER_SETTINGS_BY_ACEPID,
      });
      try {
        const response = await fetch(
          `https://ws.acep.org/aceptoolkit/api/2015/contactdetailsbyid?acepid=${ACEPID}`,
          {
            method: 'GET',
            headers,
          },
        );
        const json = await response.json();
        const acepExpirationDate = moment(json.acepExpirationDate).format(
          'MMMM D, YYYY',
        );
        var _ssoUser = null;
        var obj = {
          firstName: json.firstName,
          acepid: ACEPID,
          loginUI_ExpiryDate: `Membership Exp: ${acepExpirationDate}`,
          loginUI_Join: json.loginUI_Join,
          avatar: json.avatar,
        };
        _ssoUser = JSON.stringify(obj);
        dispatch({
          type: SET_USER_SETTINGS_BY_ACEPID_FULFILLED,
          userSettings: json,
          ssoUser: _ssoUser,
        });
      } catch (error: any) {
        dispatch({
          type: SET_USER_SETTINGS_BY_ACEPID_FAILED,
          error: error.message,
        });
      }
    };
  },
  setJWTTokenGlobalHeader: () => {
    return async (dispatch: Dispatch<KnownAction>) => {
      dispatch({
        type: FETCHING_SSO_USER_ACEPID,
      });
      try {
        const response = await fetch(
          `https://signin.acep.org/spapi/api/Authorization`,
          {
            credentials: 'include',
          },
        );
        const json = await response.text();
        let parsedToken = parseJWT(json);
        const acepID = parsedToken.sub;
        dispatch({
          type: SET_SSO_USER_ACEPID_FULFILLED,
          acepID: acepID,
        });
      } catch (error: any) {
        dispatch({
          type: SET_SSO_USER_ACEPID_FAILED,
          error: error.message,
        });
      }
    };
  },
};
